module.exports = __webpack_public_path__ + "static/media/g-user.420b5d53.png";